"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LinkUnlinkFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LinkUnlinkFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.843 1.203a4.106 4.106 0 0 1 5.806 0l.148.148a4.107 4.107 0 0 1 0 5.807l-2.314 2.315a1 1 0 0 1-1.415-1.414l2.315-2.315a2.107 2.107 0 0 0 0-2.98l-.148-.147a2.106 2.106 0 0 0-2.978 0L7.942 4.932a1 1 0 0 1-1.414-1.414l2.315-2.315ZM4.932 6.527a1 1 0 0 1 0 1.414l-2.315 2.315a2.107 2.107 0 0 0 0 2.98l.148.147a2.106 2.106 0 0 0 2.978 0l2.315-2.315a1 1 0 0 1 1.414 1.414l-2.315 2.315a4.106 4.106 0 0 1-5.807 0l-.147-.148a4.107 4.107 0 0 1 0-5.807l2.314-2.315a1 1 0 0 1 1.415 0ZM0 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1ZM13 10a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM5 4a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1ZM10 15a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0v2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LinkUnlinkFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LinkUnlinkFill;
exports["default"] = _default;